import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight } from 'lucide-react';
import { PRODUCT_GROUPS } from '../data/productNav';

// "Everything MoneyFeed does" — showcases every product page and internally links them
// from the homepage (visibility + SEO link equity).
export const SolutionsSection = () => (
  <section className="mb-16" data-testid="solutions-section">
    <div className="text-center mb-10">
      <p className="text-sm font-bold text-[#84CC16] uppercase tracking-wider mb-2">One app, everything money</p>
      <h2 className="text-3xl md:text-4xl font-bold text-[#064E3B]">Everything MoneyFeed does</h2>
      <p className="text-gray-600 mt-3 max-w-2xl mx-auto text-sm md:text-base">
        Capture on WhatsApp, scan receipts, invoice clients and export tax-ready reports — pick where you want to start.
      </p>
    </div>

    <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-5">
      {PRODUCT_GROUPS.map((group) => (
        <div key={group.title} className="bg-white rounded-2xl shadow-md p-5 flex flex-col" data-testid={`solutions-group-${group.title.toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/^-|-$/g, '')}`}>
          <div className="flex items-center gap-2 mb-4">
            <div className="w-9 h-9 rounded-xl bg-[#F0FDF4] flex items-center justify-center">
              <group.icon className="h-5 w-5 text-[#064E3B]" />
            </div>
            <h3 className="font-bold text-[#064E3B] text-sm">{group.title}</h3>
          </div>
          <div className="space-y-1.5 flex-1">
            {group.items.map((p) => (
              <Link
                key={p.to}
                to={p.to}
                data-testid={`solutions-link-${p.to}`}
                className="flex items-center gap-2 text-sm text-gray-600 hover:text-[#064E3B] font-medium group py-1"
              >
                <p.icon className="h-4 w-4 text-[#84CC16] flex-shrink-0" />
                <span className="flex-1">{p.label}</span>
                <ArrowRight className="h-3.5 w-3.5 opacity-0 group-hover:opacity-100 group-hover:translate-x-0.5 transition-all text-[#064E3B]" />
              </Link>
            ))}
          </div>
        </div>
      ))}
    </div>
  </section>
);

export default SolutionsSection;
